import classes from "./css/NextShowCard.module.css";

const NextShowCard = (props) => {
  return (
    <div className={classes.main} style={props.main_style}>
      <img
        src={props.image}
        alt="last show"
        className={classes.image}
        style={{ objectPosition: `${props.objectPosition}` }}
      />
      <div className={classes.info_next_shows} style={props.info_style}>
        <h3>{props.date}</h3>
        <h3>{props.title}</h3>
        <h5 style={{ marginTop: "1em" }}>{props.author}</h5>
      </div>
    </div>
  );
};

export default NextShowCard;
